import { render, staticRenderFns } from "./AppPromoFooterDesktop.vue?vue&type=template&id=fd446b6c&scoped=true"
import script from "./AppPromoFooterDesktop.vue?vue&type=script&lang=js"
export * from "./AppPromoFooterDesktop.vue?vue&type=script&lang=js"
import style0 from "./AppPromoFooterDesktop.vue?vue&type=style&index=0&id=fd446b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd446b6c",
  null
  
)

export default component.exports